export default "__VITE_ASSET__BKf3Ji2T__"